<template>
  <v-container>
    <bread-crumbs :items="breadcrumbs" />

    <h2 class="text-h5 font-weight-bold mb-4">
      Áreas de {{ cliente.nombre }}
    </h2>

    <v-data-table
      :headers="[
        { text: 'ID',     value: 'id'     },
        { text: 'Nombre', value: 'nombre' }
      ]"
      :items="areas"
      class="elevation-1"
      @click:row="goToProyectos"
    />
  </v-container>
</template>

<script>
import axios from 'axios'
import BreadCrumbs from '@/components/BreadCrumbs.vue'

export default {
  name: 'AreasView',
  components: { BreadCrumbs },
  props: ['clienteId'],
  data() {
    return {
      cliente: {},
      areas: []
    }
  },
  computed: {
    breadcrumbs() {
      return [
        { text: 'CLIENTES', to: { name: 'Clientes' } },
        { text: this.cliente.nombre }
      ]
    }
  },
  async created() {
    try {
      // 1) Obtener datos del cliente desde /clients/:clienteId
      const { data: c } = await axios.get(`/clients/${this.clienteId}`)
      this.cliente = c

      // 2) Obtener las áreas desde /clients/:clienteId/areas
      const { data: a } = await axios.get(
        `/clients/${this.clienteId}/areas`
      )
      this.areas = a
    } catch (err) {
      console.error('Error cargando cliente o áreas:', err)
    }
  },
  methods: {
    goToProyectos(area) {
      this.$router.push({
        name: 'Proyectos',
        params: {
          clienteId: this.clienteId,
          areaId: area.id
        }
      })
    }
  }
}
</script>

<style scoped>
/* Tus estilos aquí */
</style>
